import t from "./component-library216.js";
/* empty css                     */
import a from "./component-library98.js";
var n = function() {
  var r = this, s = r._self._c, e = r._self._setupProxy;
  return e.isPossible ? s("span", { staticClass: "charger" }, [e.isIncluded !== null ? s(e.ChargerBox, { attrs: { "is-included": e.isIncluded } }) : r._e(), e.wattsText ? s(e.ChargerLabel, { attrs: { pd: e.hasPd, watts: e.wattsText } }) : r._e()], 1) : r._e();
}, _ = [], c = /* @__PURE__ */ a(
  t,
  n,
  _,
  !1,
  null,
  "9dce8ec9"
);
const p = c.exports;
export {
  p as default
};
